import { Link } from "react-router-dom";
import LogoMark from "@/components/LogoMark";
import { PHONE_DISPLAY, STORE_ADDRESS, STORE_CITY } from "@/config";

const LINKS = [
  { href: "#categorias", label: "Categorias" },
  { href: "#catalogo", label: "Catálogo" },
  { href: "#servicos", label: "Serviços" },
  { href: "#sobre", label: "Sobre" },
  { href: "#contato", label: "Contato" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-parchment/10 bg-forest text-parchment">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:px-12 md:grid-cols-3 lg:px-20">
        <div>
          <LogoMark dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-parchment/60">
            Casa de rações e produtos para pet e campo. Tradição, cuidado e nutrição para quem faz a
            terra e a vida florescer.
          </p>
        </div>
        <nav aria-label="Links do rodapé">
          <p className="mb-5 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-ochre">
            Navegação
          </p>
          <ul className="space-y-3">
            {LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={`footer-link-${link.label.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
                  className="text-sm text-parchment/70 transition-colors hover:text-ochre"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="mb-5 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-ochre">
            Onde estamos
          </p>
          <p className="text-sm text-parchment/70">
            {STORE_ADDRESS}
            <br />
            {STORE_CITY}
            <br />
            {PHONE_DISPLAY}
          </p>
          <p className="mt-4 text-sm text-parchment/70">Seg a Sáb — 9h às 20h</p>
        </div>
      </div>
      <div className="border-t border-parchment/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-parchment/50 sm:flex-row sm:px-12 lg:px-20">
          <p>© 2026 Agro Carmo — Todos os direitos reservados.</p>
          <p className="font-mono uppercase tracking-[0.2em]">Ração boa · Terra forte · Bicho feliz</p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="transition-colors hover:text-ochre"
          >
            Área do Lojista
          </Link>
        </div>
      </div>
    </footer>
  );
}
